import Link from '@/components/link-component'

import { TypeComponentTileLink } from '@/types/ctf'
import { cx } from '@/utils/strings'

type TileLinkProps = TypeComponentTileLink<'WITHOUT_UNRESOLVABLE_LINKS'>['fields'] & {
  /**
   * Meant for subgrid purposes, hides the subtext (description) of the tile link if true.
   */
  hideSubtext?: boolean
}

export default function TileLink({
  link,
  icon,
  title,
  subtext,
  badgeText,
  hideSubtext,
  plausibleEventName,
}: TileLinkProps) {
  return (
    <Link
      to={link?.fields.url}
      className={cx(
        'relative text-primaryBlue shadow-even-around-small dark:shadow-dark-even-around-small rounded-lg',
        'p-3 border-2 border-white hover:border-primaryBlue',
        'grid grid-cols-subgrid place-items-center flex-wrap dark:border-secondary-800 dark:text-white dark:hover:border-primaryBlue',
        plausibleEventName
      )}
    >
      {badgeText && (
        <span className="text-eyebrow uppercase absolute -top-2 -right-2 bg-primaryBlue text-white text-xs font-semibold py-1 px-2 rounded-full">
          {badgeText}
        </span>
      )}
      <span className="font-bwi text-4xl leading-1 text-center align-middle my-2">
        {icon?.fields.unicode && String.fromCodePoint(parseInt(icon.fields.unicode, 16))}
      </span>

      <p className="m-0 text-balance text-center leading-[1.25]">{title}</p>
      {!hideSubtext && (
        <p
          className={cx(
            'mt-1 text-sm text-balance text-secondary-500 dark:text-secondary-300',
            !subtext && 'invisible'
          )}
        >
          {subtext || '\u00A0'}
        </p>
      )}
    </Link>
  )
}
